import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (props) => dispatch => 
{
    axios.get('slot_free_spin/list', {params: props})
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.LIST,
            value: response.data
        })
    })
    .catch(err => 
    {
        
    });
};

export const getDropDown = () => (dispatch) =>
{
    axios.get('slot_free_spin/drop_down')
    .then(function (response)
    {
        dispatch (
        {
            type: actionType.DROPDOWN,
            value: response.data
        })
    })
    .catch(err =>
    {

    });
};

export const store = (data) => dispatch =>
{
    // console.log(data);
    axios.post('slot_free_spin/store', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.STORE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const show = (data) => (dispatch, getState) => 
{
    data.country_id = getState().currentUser.data.country_id;
    data.lang_id = getState().currentUser.data.language_id;
    data.language = getState().currentUser.data.language_code;
    axios.get("slot_free_spin/show" , {params: data})
    .then((res) => {
        dispatch({
            type: actionType.SHOW,
            value: res.data
        })
    })
    .catch((err) => {

    })
};

export const getFreeSpinMember = (props) => (dispatch, getState) =>
{
    axios.get('slot_free_spin/get_free_spin_member',{params: props})
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.GET_FREE_SPIN_MEMBER,
            value: response.data
        })
    })
    .catch(function (error) 
    {
    
    });
};

export const addFreeSpinMember = (data) => (dispatch, getState) => 
{
    axios.post("slot_free_spin/add_free_spin_member", data)
    .then((response) => {
        dispatch({
            type: actionType.ADD_FREE_SPIN_MEMBER,
            value: response.data,
        });
    })
    .catch(function (error) 
    {

    });
};